import { Col, Descriptions, message, Row, Select, Spin } from 'antd';
import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { getFullUserInstallmentsAdvance, getPaymentCyclesApi } from '../../utils/apisConsts';
import { request } from '../../apis';
import moment from 'moment';
import { errorMessage } from '../../utils/commonStringsConsts';
import { OutPutResult , DataTable} from '@operations/shared';
import helper from '../../utils/helper';

function ViewEarlySettlement({ userInfo }: { userInfo: { [key: string]: any } }) {
    const { Option } = Select;
    const dispatch = useDispatch()
    const [isErrorPaymentCycles, setIsErrorPaymentCycles] = useState(false)
    const [paymentCycles, setPaymentCycles] = useState<{ [key: string]: any }>([])
    const [loadingData, setLoadingData] = useState(false)
    const [selectedPaymentCycle, setSelectedPaymentCycle] = useState<number>(0);
    const [loadingTableData, setLoadingTableData] = useState(false)
    const [installments, setInstallment] = useState<any[]>([])
    const [fullEarlySettlement, setFullEarlySettlement] = useState<any>({});
    const [columns, setColumns] = useState<any[]>([])
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 5,
        total: 0,
    })

    const getPaymentCycles = async () => {
        const params = {
            companyID: userInfo?.companyID,
            mostRecent: true
        }
        try {
            const paymentCyclesRes: { [key: string]: any } = await dispatch(request({ url: getPaymentCyclesApi, method: "GET", params: params }))
            if (paymentCyclesRes?.data?.status === 200) {
                const todayDate = new Date()
                const payerDate = new Date()
                payerDate.setDate(userInfo?.actualCutOffDate)
                if (payerDate <= todayDate) {
                    payerDate.setMonth(payerDate.getMonth() + 1)
                }
                const currentCycle = {
                    cutOffCycleDate: payerDate,
                    paymentCycle: Number(paymentCyclesRes?.data?.allPaymentCycles?.paymentCycle) + 1
                }
                setPaymentCycles([paymentCyclesRes?.data?.allPaymentCycles, currentCycle])
            } else {
                message.error(paymentCyclesRes?.data?.message)
                setIsErrorPaymentCycles(true)
            }
        }
        catch (error: any) {
            setIsErrorPaymentCycles(true)
            setLoadingData(false)
        }
    }

    const handleTableChange = (e: any) => {
        setLoadingTableData(true)
        setTimeout(() => {
            setPagination(e)
            setLoadingTableData(false)
        }, 500);
    }

    const getFullInstallmentsAdvances = async (paymentCycle: number) => {
        try {
            setLoadingTableData(true)
            const fullInstallmentsRes: { [key: string]: any } = await dispatch(request({
                url: getFullUserInstallmentsAdvance, method: "GET", params: {
                    userID: userInfo?.userID, paymentCycle
                }
            }))

            if (fullInstallmentsRes?.status === 200) {
                const installmentsData = Array.isArray(fullInstallmentsRes?.data?.data?.advances) ?
                    fullInstallmentsRes?.data?.data?.advances.map((installment: any) => ({
                        "User ID": installment?.userID,
                        "User Name": installment?.userName,
                        "Advance ID": installment?.advanceID,
                        "Service Name": installment?.serviceName,
                        "dateOfRequest": moment(installment?.dateOfRequest).format('Do MMM, YYYY'),
                        "requestedAmount": installment?.requestedAmount,
                        "Upcoming Amount": installment?.upcomingAmount,
                        "Upcoming Principal": installment?.upcomingPrincipal,
                        "Upcoming External Payments": installment?.upcomingExternalPayments,
                        "Upcoming Revenue": installment?.upcomingRevenue,
                        "Upcoming Discount": installment?.upcomingDiscount,
                        "Upcoming Net Revenue": installment?.upcomingNetRevenue,
                        "Six Percent Of Principal": installment?.sixPercentOfPrincipal,
                        "Early Settlement Discount": installment?.earlySettlementDiscount,
                    })) : []
                !fullInstallmentsRes?.data?.data?.advances.length && message.success('User has no installments yet')
                handleTableChange({
                    current: 1,
                    total: fullInstallmentsRes?.data?.data?.advances.length,
                    pageSize: 5
                })
                setInstallment(installmentsData)
                setColumns(helper.generateTableColumns(installmentsData))
                setFullEarlySettlement({
                    totalUpcomingAmount: fullInstallmentsRes?.data?.data?.totalUpcomingAmount ?? 0,
                    totalUpcomingPrincipal: fullInstallmentsRes?.data?.data?.totalUpcomingPrincipal ?? 0,
                    totalUpcomingExternalPayments: fullInstallmentsRes?.data?.data?.totalUpcomingExternalPayments ?? 0,
                    totalUpcomingRevenue: fullInstallmentsRes?.data?.data?.totalUpcomingRevenue ?? 0,
                    totalUpcomingDiscount: fullInstallmentsRes?.data?.data?.totalUpcomingDiscount ?? 0,
                    totalUpcomingNetRevenue: fullInstallmentsRes?.data?.data?.totalUpcomingNetRevenue ?? 0,
                    totalEarlySettlementDiscount: fullInstallmentsRes?.data?.data?.totalEarlySettlementDiscount ?? 0,
                    dueAmount: fullInstallmentsRes?.data?.data?.dueAmount ?? 0,
                    discountPercentageFromRevenue: fullInstallmentsRes?.data?.data?.discountPercentageFromRevenue ?? 0,
                    earlySettlementDiscountRule: fullInstallmentsRes?.data?.data?.earlySettlementDiscountRule ?? 0,
                });
            } else if (fullInstallmentsRes?.status !== 200) {
                message.error(fullInstallmentsRes?.message)
                setInstallment([])
            }
        }
        catch (error: any) {
            message.error(errorMessage)
            setLoadingTableData(false)
            setInstallment([])
        }
    }

    useEffect(() => {
        getPaymentCycles()
        // eslint-disable-next-line
    }, [])

    return (
        isErrorPaymentCycles ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage}
            btnTitle={'Refresh the page'} btnClick={helper.refreshPage} />
            : <Spin size="large" spinning={loadingData || loadingTableData}><div className='mt-20'>
                <label >Invoice Month <span>*</span></label>
                <Row>
                    <Col span={8}>

                        <Select placeholder="Select a month" className='w-full mt-10' onChange={(cycle: number) => {
                            setSelectedPaymentCycle(cycle);
                            getFullInstallmentsAdvances(cycle)
                        }} >
                            {Array.isArray(paymentCycles) &&
                                paymentCycles.map((paymentCycle: { id: number, paymentCycle: number, cutOffCycleDate: string, isLocked: boolean }) =>
                                    <Option
                                        key={paymentCycle.id}
                                        value={paymentCycle.paymentCycle}
                                        disabled={paymentCycle.isLocked}
                                    >
                                        {moment(paymentCycle.cutOffCycleDate).format('Do MMM, YYYY')}
                                    </Option>
                                )}
                        </Select>
                    </Col>
                    <Col span={24} className='mt-20'>

                        <>
                            <h3>User information</h3>
                            <Descriptions bordered style={{ margin: '15px 0' }}>
                                <Descriptions.Item label="Name">{userInfo?.name ? userInfo?.name : 'NA'}</Descriptions.Item>
                                <Descriptions.Item label="Phone">{userInfo?.phone ? userInfo?.phone : 'NA'}</Descriptions.Item>
                                <Descriptions.Item label="Company">{userInfo?.companyName ? userInfo?.companyName : 'NA'}</Descriptions.Item>
                            </Descriptions>
                        </>

                    </Col>
                </Row>
                {selectedPaymentCycle && !loadingTableData ?
                    <Col span={24}>
                        <h3>Amount</h3>
                        <Descriptions bordered style={{ margin: '15px 0' }} column={3}>

                            {Object.entries(fullEarlySettlement)?.map(([key, value]) => (
                                <Descriptions.Item key={key} label={helper.unCamelCase(key)}>{String(value)}</Descriptions.Item>
                            ))}
                        </Descriptions>
                    </Col>
                    : null}
                {(Array.isArray(installments) && installments.length > 0) ? <Row>
                    <Col>
                        <label className="tableLabel">User Installments</label>
                    </Col>
                    <Col span='24' className="btnCol">
                        <DataTable columns={columns} pagination={pagination} rows={installments} handleTableChange={handleTableChange}
                            loading={loadingTableData} scrolling={{ x: 2000 }} />
                    </Col>
                </Row>
                    : null
                }
            </div></Spin>
    )
}

export default ViewEarlySettlement